
/* @ngInject */
export default class UserAuthService {
    constructor($http, $q, HPConfig) {
        this.$q = $q;
        this.$http = $http;
        this.HPConfig = HPConfig;
        this.cache = {};
        this.userId = null;
    }

    getUserData() {
        return this.$http.get(`${this.HPConfig.heroProApi}User`);
    }

    getAuthorization() {
        const deferred = this.$q.defer();

        if (this.userId !== null && this.cache[this.userId] !== undefined) {
            deferred.resolve(this.cache[this.userId]);
        } else {
            this.getUserData()
                .then((result) => {
                    this.userId = result.data.Data.ContractorUserId;
                    this.cache[this.userId] = result.data.Data;
                    deferred.resolve(this.cache[this.userId]);
                })
                .catch((err) => {
                    deferred.reject(err);
                });
        }

        return deferred.promise;
    }

    getRegistrationInfo(licenseNumber) {
        return this.$http.get(`${this.HPConfig.heroProApi}Contractor/RegistrationInfo?LicenseNumber=${licenseNumber}`);
    }

    deleteAuthorization() {
        if (this.userId !== null || this.cache[this.userId] !== undefined) {
            this.userId = null;
            this.cache = {};
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/common/userAuthorization/userAuthFactory.js